import { CATEGORY_UPLOAD_STATUSES } from '../constants'

export default {
  blockNavigation: state => {
    //For now only blocking for uploading/removing but may extend in the future
    const anyUploading = Object.values(state.uploadStatuses).some(
      reason => reason === CATEGORY_UPLOAD_STATUSES.UPLOADING
    )
    const anyRemoving = Object.values(state.uploadStatuses).some(
      reason => reason === CATEGORY_UPLOAD_STATUSES.REMOVING
    )
    if (anyUploading) {
      return { reason: 'uploading' }
    } else if (anyRemoving) {
      return { reason: 'removing' }
    } else {
      return false
    }
  }
}
